<template>
  <div ref="echartParent" class="panel panel-grid-item" :class="{'bg-slate-300': editable , 'bg-white': !editable}">
    <!-- Iconos acciones -->
    <div :class="{ 'vue-draggable-handle glyphicon glyphicon-move': editable }"></div>
    <div
      :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
      @click="onClickEliminar()"
    ></div>
    <div
      :class="{ 'vue-collapsable-handle glyphicon glyphicon-chevron-up': !collapsed && !editable }"
      style="color: #4d4d4d !important;"
      @click="cambiarCollapsed(true)"
    ></div>
    <div
      :class="{ 'vue-collapsable-handle glyphicon glyphicon-chevron-down': collapsed && !editable }"
      style="color: #4d4d4d !important;"
      @click="cambiarCollapsed(false)"
    ></div>
    <!-- //Iconos acciones -->
    <!-- Modo editando -->
    <div class="pl-4 bg-slate-300" style="height: 100%;" v-if="editable && !collapsed">
      <span
        :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }"
      >{{ titulo }}</span>
    </div>
    <!-- Modo editando -->
    <!-- Modo mostrar grafico -->
    <div class="pl-4" v-if="!editable && !collapsed">
      <span
        class="titulo-colapsado"
      >{{ titulo }}</span>
    </div>
    <v-chart
      v-if="!editable && !collapsed"
      :style="`width: 96% !important; height: ${graficoHeight}px !important; padding:33px 13px; top: -19px;`"
      :theme="tuTheme"
      :options="option" 
    />
    <!-- //Modo mostrar grafico -->
    <!-- Modo colapsado -->
    <div
      v-else
      class="pl-4"
      :class="{'pointer' : !editable}"
      @click="!editable ? cambiarCollapsed(false) : null"
    >
      <span
        v-if="!editable"
        :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }"
      >{{ titulo }}</span>
    </div>
      <!-- /* posibilidad de cambiar los estilos del grafico  */ -->
      <!-- <div id="tool-panel" v-if="config.usaPlantilla && !editable && !collapsed">
        <div id="theme">
          <a  @click="tuTheme='light'" class="light" :class="['light' === tuTheme ? 'selected' : '']"><span></span></a>
          <a  @click="tuTheme='walden'" class="walden" :class="['walden' === tuTheme ? 'selected' : '']"><span></span></a>
          <a  @click="tuTheme='westeros'" class="westeros" :class="['westeros' === tuTheme ? 'selected' : '']"><span></span></a>
          <a  @click="tuTheme='macarons'" class="macarons" :class="['macarons' === tuTheme ? 'selected' : '']"><span></span></a>
        </div>
      </div> -->
    <!-- //Modo colapsado -->
  </div>
</template>
<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/map";
import "echarts/lib/chart/radar";
import "echarts/lib/chart/scatter";
import "echarts/lib/chart/effectScatter";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/polar";
import "echarts/lib/component/geo";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/dataset";
import "echarts/map/js/world";
import "zrender/lib/svg/svg";
import "echarts/theme/macarons";
import "echarts/theme/roma";
import "echarts/theme/shine";
// import "echarts/theme/walden";
// import "echarts/theme/westeros";

export default {
  components: {
    "v-chart": ECharts
  },
  props: {
    data: Object,
    config: Object,
    editable: Boolean,
    collapsed: Boolean,
    altura: Number
  },
  data() {
    return {
      bip_item_id: Number(this.$route.query.tienda),
      graficoHeight: 500,
      defaultGraficoHeight: 500,
      tuTheme: 'macarons',
      option: {},
      titulo: ''
    };
  },
  created() {
    this.setConfig();
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowHeight);

      //Init
      this.getWindowHeight();
    });
  },
  watch: {
    config: {
      handler(n, o) {
        if (o === undefined || n !== o) {
          this.setConfig();
          this.setGraficoHeight();
        }
      },
      deep: true
    },
    editable: {
      handler(n, o) {
        if (o === undefined || n !== o) {
          this.setGraficoHeight();
        }
      },
      deep: true
    }
  },
  methods: {
    onClickEliminar() {
      if (this.config.id !== undefined && this.config.id != null) {
        this.$emit("eliminarechart", this.config.id);
      }
    },
    getWindowHeight() {
      this.windowHeight = document.documentElement.clientHeight;
      this.setGraficoHeight();
    },
    setConfig() {
      if (this.config !== undefined) {
        this.titulo = this.config.title.text;
        this.config.title.show = false;
        // this.config.title.textStyle.fontSize = 18
        this.option = this.config;
      }
    },
    setGraficoHeight() {
      if (
        this.$refs.echartParent !== undefined &&
        this.$refs.echartParent !== undefined
      ) {
        if (
          this.$refs.echartParent.clientHeight - 10 <
          this.defaultGraficoHeight
        ) {
          this.graficoHeight = this.defaultGraficoHeight;
        } else {
          this.graficoHeight = this.$refs.echartParent.clientHeight - 10;
        }
      }
    },
    cambiarCollapsed(value) {
      let collapseOptions = {};
      collapseOptions.collapse = value;
      collapseOptions.id = this.config.id;
      collapseOptions.tipo = this.config.tipo;
      collapseOptions.altura = this.altura;
      this.$emit("collapse", collapseOptions);
    }
  }
};
</script>